import Vue from 'vue';
import Vuex from 'vuex';
import User from './modules/user';
import Header from './modules/header';
import Page from './modules/page';
import SnackBar from './modules/snackbar';
import Loading from './modules/loading';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    User,
    Header,
    Page,
    SnackBar,
    Loading
  },
  plugins: [createPersistedState()],
})